export enum IntelligenceFormFieldsEnum {
    QUESTION_KEY = "question_key",
    QUESTIONS = "questions",
    QUESTION_ID = "question_id",
    QUESTION_NAME = "question_name",
    QUERY_CONFIG = "query_config",
    JSON_QUERY = "json_query",
    JSON_QUERY_BUILDER_CONFIG = "json_query_builder_config",
    SELECTED_ASSETS_OR_FILTERS = "selected_assets_or_filters",
    QUERY_DEPENDENCIES = "query_dependencies",
    QUERY_DEPENDENCIES_TYPE = "query_dependencies_type",

    INSTALL_DATE = "install_date",
    ONBOARDING_DATE = "onboarding_date",
    COUNTRY = "country",
    MEDIA_SOURCE = "media_source",
    DEVICE_MODAL = "device_modal",
    DEVICE_CATEGORY = "device_category",
    FIRST_APP_VERSION = "first_app_version",
    LAST_APP_VERSION = "last_app_version",

    PRODUCT_CODE = "product_code",
    PLATFORM = "platform",
    TIME_RANGE = "time_range",
    FILTER_NAME = "filter_name",
    FILTER_OPERATOR = "filter_operator",
    FILTER_VALUES = "filter_values",
    FILTERS_SELECTED = "filter_selected",
    QUERY_ORDER = "query_order",
    QUERY_LIMIT = "query_limit",
    IS_INIT_FORM_WITH_PARAMS = "is_init_form_with_params",
}
